import styled from 'styled-components'

import { applyIPadOnlyStyle, getResponsiveFontSizeCSS } from 'helpers/css'

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
`

export const Title = styled.h1`
    font-family: AvenirBold;
    font-size: ${getResponsiveFontSizeCSS(20, 26)};
    font-style: normal;
    font-weight: 600;
    line-height: 27px;
    letter-spacing: 0em;
    text-align: left;
    color: #e87d7c;
    ${applyIPadOnlyStyle(
        `
        font-size: 18px,
        line-height: 20px,
        margin-top: 20px
    `,
        {
            min: 0,
            max: 800,
            orientation: 'both',
        }
    )}

    ${applyIPadOnlyStyle(
        `margin-top: 10px
    `,
        {
            min: 0,
            max: 800,
            orientation: 'landscape',
        }
    )}
`

export const SubText = styled.p`
    font-family: AvenirBold;
    font-size: ${getResponsiveFontSizeCSS(14, 16)};
    font-style: normal;
    font-weight: 400;
    line-height: 21px;
    letter-spacing: 0em;
    margin-top: 1vh;
    text-align: left;
    color: #898989;
    ${applyIPadOnlyStyle(
        `
        font-size: 14px,
        margin: 7px 0px,
        color: white
    `,
        {
            min: 0,
            max: 1370,
            orientation: 'both',
        }
    )}
`
